// D6-3 — THE ONE CHART SHAPE THE DASHBOARD USES.
//
// Her ranged tabs want rooms ranked, generations by type, member growth, Lala volume and vendor cost
// by day. That is five charts, and five hand-rolled bar lists is five chances for one of them to
// scale wrong. This is the single shape: a label, a value, and a bar drawn as a PERCENTAGE OF THE
// LARGEST ROW — never of a fixed width, which is how a chart quietly stops meaning anything when the
// numbers grow.
//
// Props in, tree out, no hook and no fetch, so `scripts/d6-command-center.mjs` CALLS it and reads
// the bars back rather than looking at its source text.
//
// D6-M6, HER PHONE STANDARD: it is a list, not a canvas. A list is legible at 390px by
// construction, and every row is full width, so nothing here needs a second mobile layout.

export type BarRow = { key: string; label: string; value: number; note?: string };

// A bar is drawn against the largest row, and the FLOOR is the point of this line: a room with one
// visit beside a room with four hundred would otherwise draw a bar of zero pixels, which reads as
// "nothing happened here" when what happened was one.
export function barWidth(value: number, max: number) {
  const v = Number(value) || 0;
  const m = Number(max) || 0;
  if (!m || v <= 0) return 0;
  return Math.max(3, Math.round((v / m) * 100));
}

export function OwnerBars({
  rows, empty = "Nothing in this window.", format,
}: {
  rows: BarRow[];
  empty?: string;
  format?: (value: number) => string;
}) {
  const max = rows.reduce((m, r) => Math.max(m, Number(r.value) || 0), 0);
  return (
    <ul className="owner-bars owner-bars--chart">
      {!rows.length ? <li className="owner-bars__empty">{empty}</li> : null}
      {rows.map((r) => (
        <li key={r.key}>
          <span className="owner-bars__fill" style={{ width: `${barWidth(r.value, max)}%` }} aria-hidden="true" />
          <span className="owner-bars__label">
            {r.label}
            {r.note ? <em className="owner-bars__note">{r.note}</em> : null}
          </span>
          <span className="owner-bars__count">{format ? format(r.value) : Number(r.value).toLocaleString("en-US")}</span>
        </li>
      ))}
    </ul>
  );
}
